import { cn } from "@/lib/utils"

interface RomanizationLoaderProps {
  isEnglish: boolean
  error?: string
}

export default function RomanizationLoader({
  isEnglish,
  error,
}: RomanizationLoaderProps) {
  if (error) {
    return (
      <div className="flex flex-col gap-1">
        <span
          className={cn(
            "text-xs font-medium tracking-wide uppercase",
            isEnglish
              ? "text-red-300 dark:text-red-400"
              : "text-red-400 dark:text-red-500",
          )}
        >
          Romanization
        </span>
        <p
          className={cn(
            "text-sm leading-relaxed italic",
            isEnglish
              ? "text-red-200 dark:text-red-300"
              : "text-red-400 dark:text-red-500",
          )}
        >
          Failed to load romanization
        </p>
      </div>
    )
  }

  return (
    <div className="flex animate-pulse flex-col gap-1">
      <span
        className={cn(
          "text-xs font-medium tracking-wide uppercase",
          isEnglish
            ? "text-blue-100 dark:text-blue-200"
            : "text-slate-500 dark:text-slate-400",
        )}
      >
        Romanization
      </span>
      <p
        className={cn(
          "text-sm leading-relaxed italic",
          isEnglish
            ? "text-blue-200 dark:text-blue-300"
            : "text-slate-400 dark:text-slate-500",
        )}
      >
        Generating romanization...
      </p>
    </div>
  )
}
